var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "r-form__section-heading m-l-15 m-r-15 m-b-20" },
        [_vm._v("\n    " + _vm._s(_vm.$t("TRACKING_SETTINGS_TITLE")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("COUNT_ATTEMPTS"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("COUNT_ATTEMPTS_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("v-select", {
                      attrs: {
                        clearable: false,
                        searchable: false,
                        options: _vm.countAttempsOnSelectOptions
                      },
                      model: {
                        value: _vm.countAttempsSelected,
                        callback: function($$v) {
                          _vm.countAttempsSelected = $$v
                        },
                        expression: "countAttempsSelected"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("TRACK_CONVERSION_BY"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("TRACK_CONVERSION_BY_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("v-select", {
                      attrs: {
                        clearable: false,
                        searchable: false,
                        options: _vm.trackConversionBySelectOptions
                      },
                      model: {
                        value: _vm.trackConversionBySelected,
                        callback: function($$v) {
                          _vm.trackConversionBySelected = $$v
                        },
                        expression: "trackConversionBySelected"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "r-form__section-heading m-l-15 m-r-15" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("CALL_FILTER_SETTINGS_TITLE")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("MINIMUM_NUMBER_OF_CALLS"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("MINIMUM_NUMBER_OF_CALLS_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("ValidationProvider", { attrs: { slim: "" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.erpcSetting.minimumNumberOfCalls,
                            expression: "erpcSetting.minimumNumberOfCalls"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", placeholder: "15" },
                        domProps: {
                          value: _vm.erpcSetting.minimumNumberOfCalls
                        },
                        on: {
                          change: _vm.onChange,
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.erpcSetting,
                              "minimumNumberOfCalls",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("DESIRED_NUMBER_OF_CALLS"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("DESIRED_NUMBER_OF_CALLS_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("ValidationProvider", { attrs: { slim: "" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.erpcSetting.desiredNumberOfCalls,
                            expression: "erpcSetting.desiredNumberOfCalls"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", placeholder: "75" },
                        domProps: {
                          value: _vm.erpcSetting.desiredNumberOfCalls
                        },
                        on: {
                          change: _vm.onChange,
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.erpcSetting,
                              "desiredNumberOfCalls",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("MINIMUM_NUMBER_OF_HOURS"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("MINIMUM_NUMBER_OF_HOURS_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("ValidationProvider", { attrs: { slim: "" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.erpcSetting.minimumNumberOfHours,
                            expression: "erpcSetting.minimumNumberOfHours"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", placeholder: "" },
                        domProps: {
                          value: _vm.erpcSetting.minimumNumberOfHours
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.erpcSetting,
                              "minimumNumberOfHours",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("DESIRED_NUMBER_OF_HOURS"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("DESIRED_NUMBER_OF_HOURS_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("ValidationProvider", { attrs: { slim: "" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.erpcSetting.desiredNumberOfHours,
                            expression: "erpcSetting.desiredNumberOfHours"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", placeholder: "720" },
                        domProps: {
                          value: _vm.erpcSetting.desiredNumberOfHours
                        },
                        on: {
                          change: _vm.onChange,
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.erpcSetting,
                              "desiredNumberOfHours",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("SKIP_LATEST_HOURS"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("SKIP_LATEST_HOURS_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("ValidationProvider", { attrs: { slim: "" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.erpcSetting.skipLatestHours,
                            expression: "erpcSetting.skipLatestHours"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", placeholder: "" },
                        domProps: { value: _vm.erpcSetting.skipLatestHours },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.erpcSetting,
                              "skipLatestHours",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "r-form__section-heading m-l-15 m-r-15" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("PRIORITY_SETTINGS_TITLE")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("NEW_TARGETS_PRIORITY"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("NEW_TARGETS_PRIORITY_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("ValidationProvider", {
                      ref: "prNewTargetPriority",
                      attrs: { rules: "min_value:0", slim: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ classes }) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.erpcSetting.newTargetPriority,
                                    expression: "erpcSetting.newTargetPriority"
                                  }
                                ],
                                staticClass: "form-control",
                                class: classes,
                                attrs: {
                                  name: "prNewTargetPriority",
                                  type: "number",
                                  placeholder: "55"
                                },
                                domProps: {
                                  value: _vm.erpcSetting.newTargetPriority
                                },
                                on: {
                                  change: _vm.onChange,
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.erpcSetting,
                                      "newTargetPriority",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("Field", {
            staticClass: "col-sm-6",
            attrs: {
              label: _vm.$t("UNDER_PERFORMING_TARGETS_PRIORITY"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("UNDER_PERFORMING_TARGETS_PRIORITY_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("ValidationProvider", {
                      ref: "prUnderPerformingTargetPriority",
                      attrs: { rules: "min_value:0", slim: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ classes }) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.erpcSetting
                                        .underPerformingTargetPriority,
                                    expression:
                                      "erpcSetting.underPerformingTargetPriority"
                                  }
                                ],
                                staticClass: "form-control",
                                class: classes,
                                attrs: {
                                  name: "prUnderPerformingTargetPriority",
                                  type: "number",
                                  placeholder: "10"
                                },
                                domProps: {
                                  value:
                                    _vm.erpcSetting
                                      .underPerformingTargetPriority
                                },
                                on: {
                                  change: _vm.onChange,
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.erpcSetting,
                                      "underPerformingTargetPriority",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasRpcLegacy
        ? [
            _c(
              "div",
              { staticClass: "r-form__section-heading m-l-15 m-r-15" },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("LEGACY_SETTINGS_TITLE")) + " "
                ),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right",
                      value: _vm.$t("LEGACY_SETTINGS_TITLE_TT"),
                      expression: "$t('LEGACY_SETTINGS_TITLE_TT')",
                      modifiers: { right: true }
                    }
                  ],
                  staticClass: "fa fa-question-circle m-l-5"
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("Field", {
                  staticClass: "col-sm-4",
                  attrs: {
                    label: _vm.$t("DEFAULT_RATIO"),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t("DEFAULT_RATIO_TT")
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c("ValidationProvider", { attrs: { slim: "" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.erpcSetting.defaultRatio,
                                    expression: "erpcSetting.defaultRatio"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number" },
                                domProps: {
                                  value: _vm.erpcSetting.defaultRatio
                                },
                                on: {
                                  blur: _vm.onChange,
                                  change: _vm.onChange,
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.erpcSetting,
                                      "defaultRatio",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    560302839
                  )
                }),
                _vm._v(" "),
                _c("Field", {
                  staticClass: "col-sm-4",
                  attrs: {
                    label: _vm.$t("OVERRIDE_RATIO"),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t("OVERRIDE_RATIO_TT")
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c("ValidationProvider", { attrs: { slim: "" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.erpcSetting.overrideRatio,
                                    expression: "erpcSetting.overrideRatio"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number", placeholder: "" },
                                domProps: {
                                  value: _vm.erpcSetting.overrideRatio
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.erpcSetting,
                                      "overrideRatio",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2914010317
                  )
                }),
                _vm._v(" "),
                _c("Field", {
                  staticClass: "col-sm-4",
                  attrs: {
                    label: _vm.$t("OVERRIDE_AMOUNT"),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t("OVERRIDE_AMOUNT_TT")
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c("ValidationProvider", { attrs: { slim: "" } }, [
                              _c("span", { staticClass: "currency" }, [
                                _vm._v("$")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.erpcSetting.overrideAmount,
                                    expression: "erpcSetting.overrideAmount"
                                  }
                                ],
                                staticClass: "form-control p-l-20",
                                attrs: { type: "number", placeholder: "" },
                                domProps: {
                                  value: _vm.erpcSetting.overrideAmount
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.erpcSetting,
                                      "overrideAmount",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    112699565
                  )
                })
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }